import { type FC, type RefObject } from 'react';
import { type TileSize } from './constants.ts';
import { useTileSizeClassNames } from './hooks/useTileSizeClassNames.ts';
import classNames from 'classnames';
import styles from './styles/styles.scss';
import dibsCss from 'dibs-css';

const ShimmerLine: FC<{ dataTn: string; className: string }> = ({ dataTn, className }) => (
    <div data-tn={dataTn} className={classNames(styles.shimmer, dibsCss.rounded2px, className)} />
);

type Props = {
    size: TileSize;
    visibilityRef?: RefObject<HTMLDivElement | null>;
    imageOnly?: boolean;
};

export const BuyerProductTileShimmer: FC<Props> = ({ size, visibilityRef, imageOnly = false }) => {
    const { tileSizeClassNames, productImageClassNames } = useTileSizeClassNames({ size });

    return (
        <div
            className={classNames(!imageOnly && tileSizeClassNames, dibsCss.wFull)}
            ref={visibilityRef}
        >
            <ShimmerLine
                dataTn="product-image"
                className={classNames(productImageClassNames, !imageOnly && dibsCss.mbXsmall)}
            />
            {!imageOnly && (
                <>
                    <ShimmerLine
                        dataTn="product-title-line-1"
                        className={classNames(dibsCss.h18px, dibsCss.mbXsmall)}
                    />
                    <ShimmerLine
                        dataTn="product-title-line-2"
                        className={classNames(dibsCss.h18px, dibsCss.mbXsmall)}
                    />
                    <ShimmerLine
                        dataTn="product-pricing"
                        className={classNames(dibsCss.h18px, dibsCss.w25, dibsCss.mbXsmall)}
                    />
                </>
            )}
        </div>
    );
};
